import React, { useEffect, useState } from "react";

const ParallaxBackground = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Generate random geometric shapes
  const shapes = [
    {
      type: "circle",
      size: 60,
      x: "15%",
      y: "20%",
      opacity: 0.04,
      speed: 0.02,
    },
    {
      type: "square",
      size: 80,
      x: "80%",
      y: "40%",
      opacity: 0.03,
      speed: 0.04,
    },
    {
      type: "triangle",
      size: 70,
      x: "60%",
      y: "75%",
      opacity: 0.05,
      speed: 0.03,
    },
    {
      type: "circle",
      size: 120,
      x: "30%",
      y: "60%",
      opacity: 0.03,
      speed: 0.05,
    },
    {
      type: "square",
      size: 40,
      x: "70%",
      y: "15%",
      opacity: 0.04,
      speed: 0.02,
    },
  ];

  return (
    <div className="fixed top-0 left-0 w-screen h-screen pointer-events-none z-0 overflow-hidden">
      {shapes.map((shape, index) => {
        const yMovement = scrollY * shape.speed;
        const xMovement = scrollY * (shape.speed / 2);

        return (
          <div
            key={index}
            className="absolute"
            style={{
              left: shape.x,
              top: shape.y,
              width: `${shape.size}px`,
              height: `${shape.size}px`,
              opacity: shape.opacity,
              transform: `translate(${xMovement}px, ${yMovement}px) rotate(${
                scrollY * 0.02
              }deg)`,
            }}
          >
            {shape.type === "circle" && (
              <div
                className="w-full h-full rounded-full border border-lightText"
                style={{ opacity: shape.opacity }}
              />
            )}
            {shape.type === "square" && (
              <div
                className="w-full h-full border border-lightText"
                style={{
                  opacity: shape.opacity,
                  transform: `rotate(${45}deg)`,
                }}
              />
            )}
            {shape.type === "triangle" && (
              <div
                className="w-0 h-0 border-l-[40px] border-r-[40px] border-b-[70px] border-l-transparent border-r-transparent border-b-lightText"
                style={{ opacity: shape.opacity }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ParallaxBackground;
